import React, { createContext } from 'react';
import openSocket from 'socket.io-client';
import { getBackendUrl } from '../../config';
// import config from "../../services/config";

const socketManager = {
  currentSocket: null,

  GetSocket: function () {
    const publicToken = localStorage.getItem('public-token');

    if (publicToken !== this.currentToken) {
      if (this.currentSocket) {
        this.currentSocket.disconnect();
      }

      this.currentToken = publicToken;
      const backendUrl = getBackendUrl() || process.env.REACT_APP_BACKEND_URL;
      this.currentSocket = openSocket(backendUrl, {
        transports: ['websocket'],
        pingTimeout: 18000,
        pingInterval: 18000,
        query: publicToken ? { token: publicToken } : {},
        // auth: publicToken ? { token: publicToken } : {},
      });
    }
    return this.currentSocket;
  },

  onConnect: function (callbackConnect) {
    if (this.currentSocket && this.currentSocket.connected) {
      callbackConnect();
    }
    this.currentSocket.on('connect', callbackConnect);
  },
};

const SocketContext = createContext();

export { SocketContext, socketManager };
